import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FlexTableCol, FlexTableRow, DotNotification } from 'virtues-bootstrap';

import s from './styles.module.scss';

const ReportsListRow = ({
  id,
  patientName,
  patientId,
  language,
  lastUpdated,
  assignedTo,
  isAvailableName,
  withNotification,
}) => (
  <FlexTableRow
    className={s.row}
    to={`/patient/${patientId}/transmission-report/${id}`}
    component={Link}
  >
    {isAvailableName ? (
      <FlexTableCol>
        {withNotification ? <DotNotification className={s.dot} /> : null}
        <strong>{patientName}</strong>
      </FlexTableCol>
    ) : null}
    <FlexTableCol>{`RPM-CIED-${patientId}`}</FlexTableCol>
    <FlexTableCol>{language}</FlexTableCol>
    <FlexTableCol>{assignedTo}</FlexTableCol>
    <FlexTableCol>{lastUpdated}</FlexTableCol>
  </FlexTableRow>
);

ReportsListRow.propTypes = {
  id: PropTypes.string.isRequired,
  withNotification: PropTypes.bool,
  patientId: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  language: PropTypes.string,
  patientName: PropTypes.string.isRequired,
  assignedTo: PropTypes.string.isRequired,
  isAvailableName: PropTypes.bool.isRequired,
};

ReportsListRow.defaultProps = {
  language: null,
  withNotification: false,
};

export default ReportsListRow;
